import React from 'react';

import Snackbar from 'material-ui/Snackbar';

import Header from '../components/Header';
import SideMenu from '../components/SideMenu';
import LogsForm from '../components/Logs/Form';
import ListLogs from '../components/Logs/List';

import LogApi from '../psuite-js/apis/logger/log';

class LogsContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = { logs: [], loading: false, is_fetched: false };
    }

    onSubmit(filter) {
        if (this.state.loading) return;

        this.setState({ loading: true });

        const params = { filter, order: [['date', 'asc']], include: ['user'] };

        LogApi.all(params).then(result => {
            if (result.status === 200) {
                const data = result.data;
                const logs = data.data;
                this.setState({logs, loading: false, is_fetched: true});
            } else {
                console.error(result);
                this.setState({logs: [], loading: false});
                alert('Falha ao recuperar os dados!');
            }
        }).catch(e => {
            console.error(e);
            this.setState({logs: [], loading: false});
            alert('Falha ao recuperar os dados!');
        });
    }

    render() {
        return (
            <div>
                <Header />
                <div className="container-fw">
                    <SideMenu />

                    <div className="content">
                        <div className="flex-container logs-review">
                            <LogsForm onSubmit={this.onSubmit.bind(this)} />
                            <ListLogs data={this.state.logs} is_fetched={this.state.is_fetched} />

                            <Snackbar
                                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                                open={this.state.loading}
                                message={<span>Carregando...</span>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default LogsContainer;



// WEBPACK FOOTER //
// ./src/containers/logs.js